export default {
    namespaced: true,
    state: {
        version: process.env.PACKAGE_VERSION || '0'
    },
    getters: {
        version: (state) => {
            return state.version
        }
    }
}